export const menuObj = {
  '首页': '69',
  '项目': '1',
  '任务': '70',
  '品牌': '4',
  '供应商': '8',
  '成长': '9',
  '日程': '10',
  '所需': '14',
  '人事': '12',
  '设备': '13',
  '系统': '15',
  '资源': '72',
  'dashborad' : '78',
  '财务管理' : '7'
}
